import { useRouter } from 'next/router';

const activeDropdown = () => {
    const { asPath } = useRouter();
    if (asPath.indexOf('about-us') !== -1) {
        return 'about-us';
    } else if (asPath.indexOf('solutions') !== -1) {
        return 'solutions';
    } else if (asPath.indexOf('services') !== -1) {
        return 'services';
    } else {
        return '';
    }
};

export default activeDropdown;
